import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.modal || initialState;

export const selectModalShow = createSelector(
  [selectSlice],
  state => state.data.show,
);
export const selectModalContent = createSelector(
  [selectSlice],
  state => state.data.content,
);
